import { InputBase, withStyles } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  checkbox: {
    padding: theme.spacing(0, 1.5, 0, 0),
  },
  container: {
    width: '100%',
    display: 'block',
    boxSizing: 'border-box',
    padding: '32px',
  },
  select: {
    margin: theme.spacing(1),
    '& .MuiSelect-select:focus': {
      background: 'none',
    },
    //width: '30%',
  },
  headerBold: {
    fontWeight: 700,
  },
  boxStatus: {
    '& .MuiDataGrid-colCellTitle': {
      fontWeight: 'bold',
    },
    boxStatus: {
      '& .MuiDataGrid-row.box--read': {
        backgroundColor: '#fff !important',
      },
      '& .MuiDataGrid-row.box--unread': {
        backgroundColor: 'rgb(182, 250, 199) !important',
      },
      '& .MuiDataGrid-row.box--pending': {
        backgroundColor: 'rgb(182, 250, 199) !important',
      },
    },
    //  '& .box--read == 1': {
    //   background: 'white',
    // },
  },
  title: {
    flexGrow: 1,
    margin: theme.spacing(1),
  },
  textBox: {
    marginBottom: theme.spacing(3),
    fontSize: 14,
    maxWidth: 580,
    color: 'rgb(0 0 0 / 54%)',
  },
  fixedHeight: {
    height: 240,
  },
  margin: {
    margin: theme.spacing(1),
  },
  search: {
    //margin: theme.spacing(2),
    width: '50%',
  },
  box: {
    marginBottom: theme.spacing(2),
    width: '55%',
    paddingTop: theme.spacing(2),
    display: 'flex',
    flexDirection: 'row',
  },
  headerBtn: {
    boxShadow: 'none',
    textTransform: 'none',
    lineHeight: '36px',
    padding: `0 ${theme.spacing(3)}px`,
  },
}));

export const useStylesSecond = makeStyles((theme: Theme) => ({
  label: {
    minWidth: 'auto',
    maxWidth: 'inherit',
    padding: 0,
    fontWeight: 500,
    fontSize: 14,
  },

  title: {
    flexGrow: 1,
    fontSize: 14,
    margin: theme.spacing(1),
  },
  gridPaper: {
    height: '100%',
  },
  tabsPaper: {
    width: '100%',
    boxShadow: theme.shadows[0],
    backgroundColor: 'transparent',
    '& [class*="MuiBox-root"]': {
      padding: theme.spacing(2, 0, 0, 0),
    },
  },
  tabsPanel: {
    padding: 12,
    width: '100%',
  },
  tabBox: {
    //backgroundColor: '#ffffff',
    //marginTop: theme.spacing(2.5),
  },
  tab: {
    //backgroundColor: '#ffffff',
    marginTop: theme.spacing(2.5),
  },
  container: {
    width: '100%',
  },
  row: {
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginBottom: theme.spacing(3.5),
  },
  titlePopSmtp: {
    width: 170,
    margin: theme.spacing(0, 5, 0, 0),
    color: 'rgb(0 0 0 / 87%)',
  },
  desc: {
    width: 320,
    borderBottom: '1px solid #E0E0E0',
    padding: 5,
    color: 'rgb(0 0 0 / 87%)',
  },
  tabs: {
    width: 'fit-content',
    border: '1px solid white',
    borderRadius: '4px 0px 0px 4px',
    marginLeft: '30px',
    background: 'white',
    '& .MuiTabs-indicator': {
      backgroundColor: 'orange',
      height: 3,
    },
    '& .MuiTab-root.Mui-selected': {
      color: 'white',
      backgroundColor: '#5081FF',
    },
    '& .MuiTab-root': {
      padding: '16px 24px',
    },
  },
  badge: {
    position: 'relative',
    left: theme.spacing(-2),
  },
}));
export const BootstrapInput = withStyles((theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
    },
    input: {
      marginLeft: theme.spacing(1),

      width: theme.spacing(16),
      borderRadius: 4,
      position: 'relative',
      //background: theme.palette.action.hover,
      background: 'none',
      fontSize: 14,
      padding: 26,
    },
  })
)(InputBase);
